import { render } from "./capital-explorer.view.vue?vue&type=template&id=772b2d2e&scoped=true&ts=true"
import script from "./capital-explorer.view.vue?vue&type=script&lang=ts"
export * from "./capital-explorer.view.vue?vue&type=script&lang=ts"

import "./capital-explorer.view.vue?vue&type=style&index=0&id=772b2d2e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772b2d2e"]])

export default __exports__